import { BLOCKS } from '@contentful/rich-text-types';
import PropTypes from 'prop-types';

import {
  RichListContainer, RichText, RichTextContainer
} from './DynamicTypography.styles';

import { useLessonValues } from '../../contexts/LessonContext';

export const TextZen = ({ nodeType, className, content }) => {
  const { getLessonValue } = useLessonValues();
  const mainColor = getLessonValue('mainColor');

  if (nodeType === 'unordered-list') {
    return (
      <RichListContainer className={className}>
        {
          content.map(({ content: liContent }) => (
            <li key={JSON.stringify(liContent)}>
              {liContent.map(({ data: { classnames }, value: text }) => (
                <RichText mainColor={mainColor} size="md" tag="span" key={`${classnames}-${text}`} className={classnames}>{text}</RichText>
              ))}
            </li>
          ))
        }
      </RichListContainer>
    );
  }

  // nodeType = 'paragraph' inline
  if (nodeType === 'paragraph' && className?.includes('inline')) {
    return (
      <>
        {
          content.map(({ data: { classnames }, value: text }) => (
            <RichText tag="span" key={`${classnames}-${text}`} className={classnames}>{text}</RichText>
          ))
        }
      </>
    );
  }

  // nodeType = 'paragraph'
  return (
    <RichTextContainer size="md" tag="p" className={className}>
      {
        content.map(({ data: { classnames }, value: text }) => (
          <RichText tag="span" key={`${classnames}-${text}`} className={classnames}>{text}</RichText>
        ))
      }
    </RichTextContainer>
  );
};

TextZen.propTypes = {
  nodeType: PropTypes.string.isRequired,
  className: PropTypes.string,
  content: PropTypes.arrayOf(Object).isRequired
};

const renderFunction = (node) => {
  const { content, data: { classnames }, nodeType } = node;
  return <TextZen nodeType={nodeType} className={classnames} content={content} />;
};

export const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: renderFunction,
    [BLOCKS.UL_LIST]: renderFunction
  }
};
